import axios from 'axios';

export default {
  FETCH_LOGOS ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('common/getAllHomePageLogo')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('logos', JSON.stringify(payload));
                    commit('SET_LOGOS', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    GETSELECTEDLOGO ({ commit }, logoId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`common/getAllHomePageLogo`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;

            console.log('payload', payload)
            let selectedLogo = payload.filter(x => {
              return x.logoId.toString() === logoId.toString()
            });

            console.log('found logo', selectedLogo)
            commit('SET_SELECTED_LOGO', selectedLogo[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_LOGO({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add logo payload : ", payload);
            axios.post('common/insertHomePageLogo', payload)
                .then((response) => {
                    console.log('ADD_LOGO action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_LOGO action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_LOGOS_ORDERING ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('TOGGLE_LOADING', true);
        return axios.post(`common/updLogosDispOrder`, payload).then((response) => {
          commit('TOGGLE_LOADING', false);
          const { data: { data } } = response;
          console.log('UPDATE_LOGO_ORDER response ', response);
          resolve(data);
        }, (error) => {
          commit('TOGGLE_LOADING', false);
          console.log('UPDATE_EXPERT error ', error);
          reject(error);
        })
      })

    },
    UPDATE_LOGO({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.post('/common/updateHomePageLogo', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_LOGO action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/logos/actions.js